import styled from 'styled-components';

export const Wrapper = styled.div`
	display: grid;
	padding: 0 1rem 2rem;
`;
